<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="12">
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text" v-if="loading.getdata">
              <v-col cols="12" md="12" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
            </v-row>
            <v-row class="black--text" v-if="!loading.getdata && datalist.length > 0">
              <v-col cols="12" md="9">
                <div class="d-flex">
                  <div class="d-inline mr-5">
                    <v-img
                      :lazy-src="require('../../assets/default.jpg')"
                      max-height="70"
                      max-width="70"
                      :src="datalist[0].urlpic ? datalist[0].urlpic : ''">
                    </v-img>
                  </div>
                  <div class="d-inline">
                    <h2 class="text-md-h4 mb-2 font-weight-bold">
                      {{ datalist[0].user_firstname }} {{ datalist[0].user_lastname }}
                    </h2>
                    <v-chip
                      class="mr-1 mb-1"
                      color="deep-orange"
                      small
                      dark>
                      <v-icon left small>
                        mdi-cash-multiple
                      </v-icon>
                      {{ datalist[0].js_pref_salary ? datalist[0].js_pref_salary : 1 | rupiahformat }}
                    </v-chip>
                    <v-chip
                      class="mr-1 mb-1"
                      color="primary"
                      small
                      dark>
                      <v-icon left small>
                        mdi-map-marker
                      </v-icon>
                      {{ datalist[0].js_pref_location ? datalist[0].js_pref_location : 'Location'}}
                    </v-chip>
                    <v-chip
                      class="mr-1 mb-1"
                      color="green"
                      small
                      dark>
                      <v-icon left small>
                        mdi-account-hard-hat
                      </v-icon>
                      {{ datalist[0].js_pref_special ? datalist[0].js_pref_special : 'Specialization'}}
                    </v-chip>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="3" :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-right'">
                <v-btn
                  class="mr-2 mb-2"
                  depressed
                  color="error"
                  @click="updateProfile(datalist[0])">
                  <v-icon small left>
                    mdi-pencil
                  </v-icon>
                  Update Profile
                </v-btn>
              </v-col>
              <v-col cols="12" md="12">
                <v-tabs
                  v-model="tabdata"
                  show-arrows
                  @change="changeTab"
                  class="font-weight-bold">
                  <v-tabs-slider :color="maincolor"></v-tabs-slider>
                  <v-tab href="#recomendation" active-class="main-style-slide">
                    <v-icon
                      left
                      :color="maincolor"
                      class="mb-1">
                      mdi-star
                    </v-icon>
                    Recomendation
                  </v-tab>
                  <v-tab href="#savedjob" active-class="main-style-slide">
                    <v-icon
                      left
                      :color="maincolor"
                      class="mb-1">
                      mdi-bookmark-check
                    </v-icon>
                    My saved job
                  </v-tab>
                  <v-tab href="#applications" active-class="main-style-slide">
                    <v-icon
                      left
                      :color="maincolor"
                      class="mb-1">
                      mdi-account-tie
                    </v-icon>
                    As job applicant
                  </v-tab>
                  <v-tab href="#com-req" active-class="main-style-slide">
                    <v-icon
                      left
                      :color="maincolor"
                      class="mb-1">
                      mdi-bank-plus
                    </v-icon>
                    Company request
                  </v-tab>
                  <v-tab href="#internship" active-class="main-style-slide">
                    <v-icon
                      left
                      :color="maincolor"
                      class="mb-1">
                      mdi-school
                    </v-icon>
                    As student
                  </v-tab>
                </v-tabs>
                <v-divider></v-divider>
                <v-tabs-items :touchless="true" v-model="tabdata">
                  <v-tab-item value="recomendation">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row>
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold">
                              Find job or company
                            </div>
                            <div class="caption">
                              Find a job or company with the form below
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="paramjob.type"
                              :items="listtype"
                              label="Job Type"
                              name="jobtype"
                              prepend-inner-icon="mdi-account-hard-hat">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              prepend-inner-icon="search"
                              v-model="paramjob.keyword"
                              label="Job title, company name"
                              name="keyword">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-btn
                              class="mt-1 white--text"
                              type="submit"
                              large
                              :color="maincolor"
                              block
                              @click="getRecomFilter">
                              <v-icon left>search</v-icon> Search
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-row v-if="jobreclist.length > 0">
                              <v-col
                                class="d-flex" style="flex-direction:column"
                                cols="12"
                                md="4"
                                v-for="(job, i) in jobreclist"
                                :key="i">
                                <job :job="job"></job>
                              </v-col>
                            </v-row>
                            <v-row v-if="jobreclist.length <= 0">
                              <v-col cols="12" md="12">
                                <v-alert
                                  class="black--text"
                                  color="error"
                                  border="left"
                                  elevation="2"
                                  colored-border
                                  icon="mdi-alert-octagram">
                                  Job atau Company yang anda cari tidak ditemukan, click
                                  <a
                                    class="text-decoration-none font-weight-bold"
                                    @click="tabdata = 'com-req'">here
                                  </a>
                                  untuk menambahkan rekomendasi perusahaan sebagai tempat Magang/PKL.
                                </v-alert>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="12">
                            <infinite-loading :identifier="infiniteId" @infinite="getRecJob">
                              <div slot="spinner">Loading...</div>
                              <div slot="no-more"></div>
                              <div slot="no-results"></div>
                            </infinite-loading>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="savedjob">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="paramsave.type"
                              :items="listtype"
                              label="Job Type"
                              name="jobtype"
                              prepend-inner-icon="mdi-account-hard-hat">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              prepend-inner-icon="search"
                              v-model="paramsave.keyword"
                              label="Job title, keyword"
                              name="keyword">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-btn
                              class="mt-1 white--text"
                              type="submit"
                              large
                              :color="maincolor"
                              block
                              @click="getSaveFilter">
                              <v-icon left>search</v-icon> Search
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-row v-if="jobsavelist.length > 0">
                              <v-col
                                class="d-flex" style="flex-direction:column"
                                cols="12"
                                md="4"
                                v-for="(job, i) in jobsavelist"
                                :key="i">
                                <job :job="job"></job>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="12">
                            <infinite-loading :identifier="infiniteSaveId" @infinite="getSaveJob">
                              <div slot="spinner">Loading...</div>
                              <div slot="no-more"></div>
                              <div slot="no-results"></div>
                            </infinite-loading>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="applications">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row>
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold">
                              Apply as a job applicant
                            </div>
                            <div class="caption">
                              History of applying job as a job applicant
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-autocomplete
                              v-model="paramapp.type"
                              :items="listtype"
                              label="Job Type"
                              name="jobtype"
                              prepend-inner-icon="mdi-account-hard-hat">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              prepend-inner-icon="search"
                              v-model="paramapp.keyword"
                              label="Job title, keyword"
                              name="keyword">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-btn
                              class="mt-1 white--text"
                              type="submit"
                              large
                              :color="maincolor"
                              block
                              @click="getAppFilter">
                              <v-icon left>search</v-icon> Search
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-row v-if="jobapplist.length > 0">
                              <v-col
                                class="d-flex" style="flex-direction:column"
                                cols="12"
                                md="6"
                                v-for="(job, i) in jobapplist"
                                :key="i">
                                <jobjobseeker :job="job"></jobjobseeker>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="12">
                            <infinite-loading :identifier="infiniteAppId" @infinite="getAppJob">
                              <div slot="spinner">Loading...</div>
                              <div slot="no-more"></div>
                              <div slot="no-results"></div>
                            </infinite-loading>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="com-req">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold">
                              My company request
                              <v-icon
                                :color="maincolor"
                                class="mb-1 cursor-style"
                                @click="addCompanyreq()">
                                mdi-plus-box
                              </v-icon>
                            </div>
                            <div class="caption">
                              Click plus box button to add your request
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-row
                              v-for="(comr, i) in datacomr"
                              :key="i">
                              <v-col cols="12" md="2">
                                <h2 class="text-md-h6 font-weight-bold">
                                  {{ comr.comr_date }}
                                </h2>
                                <timeago :datetime="comr.comr_date"></timeago>
                              </v-col>
                              <v-col cols="12" md="5">
                                <h2 class="text-md-h6 font-weight-bold">
                                  {{ comr.comr_name }}
                                </h2>
                                <p class="subtitle-1">
                                  {{ comr.comr_address }}
                                </p>
                                <table class="mb-3">
                                  <tr>
                                    <td>Email</td>
                                    <td>:</td>
                                    <td>&emsp; {{ comr.comr_phone }}</td>
                                  </tr>
                                  <tr>
                                    <td>Phone</td>
                                    <td>:</td>
                                    <td>&emsp; {{ comr.comr_email }}</td>
                                  </tr>
                                </table>
                                <div class="content-editor" v-html="comr.comr_desc"></div>
                              </v-col>
                              <v-col cols="12" md="4">
                                <div>
                                  <h2 class="text-md-h6 font-weight-bold">
                                    Status
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                          class="mb-1"
                                          color="info"
                                          v-bind="attrs"
                                          v-on="on">
                                          mdi-help-circle
                                        </v-icon>
                                      </template>
                                      <ul>
                                        <li>
                                          <b>request</b>
                                          <p class="mb-0">Your request has been successfully submitted.</p>
                                        </li>
                                        <li>
                                          <b>review</b>
                                          <p class="mb-0">Your request is being reviewed.</p>
                                        </li>
                                        <li>
                                          <b>reject</b>
                                          <p class="mb-0">Your request was rejected, please check your recommendation.</p>
                                        </li>
                                        <li>
                                          <b>approve</b>
                                          <p class="mb-0">Your request has been approved.</p>
                                        </li>
                                      </ul>
                                    </v-tooltip>
                                  </h2>
                                  <p class="subtitle-1">
                                    {{ comr.comr_status }}
                                  </p>
                                </div>
                                <div>
                                  <h2 class="text-md-h6 font-weight-bold">
                                    Recomendation
                                  </h2>
                                  <div v-html="comr.comr_recommend ? comr.comr_recommend : '-'"></div>
                                </div>
                              </v-col>
                              <v-col cols="12" md="1">
                                <v-icon
                                  v-if="comr.comr_status === 'request'"
                                  :color="maincolor"
                                  class="cursor-style mr-1"
                                  @click="editCompanyreq(comr)">
                                  mdi-square-edit-outline
                                </v-icon>
                                <v-tooltip top v-if="comr.comr_status !== 'request'">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="mb-1"
                                      v-bind="attrs"
                                      v-on="on">
                                      mdi-timer-outline
                                    </v-icon>
                                  </template>
                                  <span>Your request is being processed</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="internship">
                    <v-card flat>
                      <v-card-text class="px-0">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold">
                              Apply as a student
                            </div>
                            <div class="caption">
                              History of applying job as a student
                            </div>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-row
                              v-for="(jobin, i) in datajobin"
                              :key="i">
                              <v-col cols="12" md="2">
                                <h2 class="text-md-h6 font-weight-bold">
                                  {{ jobin.appin_sesi }}
                                </h2>
                                <div class="caption">
                                  School year
                                </div>
                              </v-col>
                              <v-col cols="12" md="4">
                                <h2 class="text-md-h6 font-weight-bold">
                                  {{ jobin.job_name }}
                                </h2>
                                <div>
                                  <v-img
                                    :lazy-src="require('../../assets/default.jpg')"
                                    :src="jobin.urlpic ? jobin.urlpic : ''"
                                    max-height="70"
                                    max-width="70">
                                  </v-img>
                                </div>
                                <span class="font-weight-bold">{{ jobin.com_name }}</span>
                                <table class="mb-3">
                                  <tr>
                                    <td>Specialization</td>
                                    <td>:</td>
                                    <td>&emsp; {{ jobin.job_special }}</td>
                                  </tr>
                                  <tr>
                                    <td>Sallary</td>
                                    <td>:</td>
                                    <td>&emsp; {{ jobin.job_salary | rupiahformat }}</td>
                                  </tr>
                                  <tr>
                                    <td>Location</td>
                                    <td>:</td>
                                    <td>&emsp; {{ jobin.job_location }}</td>
                                  </tr>
                                  <tr>
                                    <td>Email</td>
                                    <td>:</td>
                                    <td>&emsp; {{ jobin.com_email }}</td>
                                  </tr>
                                  <tr>
                                    <td>Phone</td>
                                    <td>:</td>
                                    <td>&emsp; {{ jobin.com_phone }}</td>
                                  </tr>
                                  <tr>
                                    <td>Website</td>
                                    <td>:</td>
                                    <td>&emsp; {{ jobin.com_website }}</td>
                                  </tr>
                                </table>
                                <p class="subtitle-2">
                                  {{ jobin.job_preview }}
                                </p>
                              </v-col>
                              <v-col cols="12" md="4">
                                <div>
                                  <h2 class="text-md-h6 font-weight-bold">
                                    Status
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                          class="mb-1"
                                          color="info"
                                          v-bind="attrs"
                                          v-on="on">
                                          mdi-help-circle
                                        </v-icon>
                                      </template>
                                      <ul>
                                        <li>
                                          <b>apply</b>
                                          <p class="mb-0">Your application has been successfully submitted.</p>
                                        </li>
                                        <li>
                                          <b>reject</b>
                                          <p class="mb-0">Your application was rejected, please check your recommendation.</p>
                                        </li>
                                        <li>
                                          <b>approve</b>
                                          <p class="mb-0">Your application has been approved.</p>
                                        </li>
                                      </ul>
                                    </v-tooltip>
                                  </h2>
                                  <p class="subtitle-1">
                                    {{ jobin.appin_status }}
                                  </p>
                                </div>
                                <div>
                                  <h2 class="text-md-h6 font-weight-bold">
                                    Recomendation
                                  </h2>
                                  <div v-html="jobin.appin_feedback ? jobin.appin_feedback : '-'"></div>
                                </div>
                              </v-col>
                              <v-col cols="12" md="2">
                                <h2 class="text-md-h6 font-weight-bold">
                                  Document
                                </h2>
                                <ul>
                                  <li>
                                    <a
                                      class="text-decoration-none"
                                      @click="showDocument(jobin, 'permohonan')">
                                      Permohonan
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-icon
                                            v-show="jobin.appin_sk_mohon"
                                            small
                                            color="success"
                                            class="mb-1"
                                            v-bind="attrs"
                                            v-on="on">
                                            mdi-checkbox-marked-circle
                                          </v-icon>
                                          <v-icon
                                            v-show="!jobin.appin_sk_mohon"
                                            small
                                            color="error"
                                            class="mb-1"
                                            v-bind="attrs"
                                            v-on="on">
                                            mdi-alert-circle
                                          </v-icon>
                                        </template>
                                        <span v-show="jobin.appin_sk_mohon">
                                          Your document already uploaded.
                                        </span>
                                        <span v-show="!jobin.appin_sk_mohon">
                                          Please upload your document!
                                        </span>
                                      </v-tooltip>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="text-decoration-none"
                                      @click="showDocument(jobin, 'pengantar')">
                                      Pengantar
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-icon
                                            v-if="jobin.appin_sk_antar"
                                            small
                                            color="success"
                                            class="mb-1"
                                            v-bind="attrs"
                                            v-on="on">
                                            mdi-checkbox-marked-circle
                                          </v-icon>
                                          <v-icon
                                            v-if="!jobin.appin_sk_antar"
                                            small
                                            color="error"
                                            class="mb-1"
                                            v-bind="attrs"
                                            v-on="on">
                                            mdi-alert-circle
                                          </v-icon>
                                        </template>
                                        <span v-if="jobin.appin_sk_antar">
                                          Your document already uploaded.
                                        </span>
                                        <span v-if="!jobin.appin_sk_antar">
                                          Please upload your document!
                                        </span>
                                      </v-tooltip>
                                    </a>
                                  </li>
                                </ul>
                              </v-col>
                              <v-col cols="12" md="12">
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-row class="black--text" v-if="!loading.getdata && datalist.length <= 0">
              <v-col cols="12" md="12">
                <v-alert type="warning">
                  Data not available, please try refreshing the data with the button below!
                </v-alert>
                <div class="text-center">
                  <v-btn
                    fab
                    depressed
                    color="primary"
                    @click="getProfile">
                    <v-icon dark large>
                      mdi-refresh
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.profile"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.profile">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Update Profile {{ dmodaldata.profile.user_lastname }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('profile')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="10">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitUpdateProfile"
                    ref="formupdprofile"
                    v-model="formadd.company"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="8">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              v-model="dmodaldata.profile.js_pref_special"
                              :items="listspecial"
                              :rules="[rules.required]"
                              label="Specialization">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              v-model="dmodaldata.profile.js_pref_location"
                              :items="listlocation"
                              :rules="[rules.required]"
                              label="Location">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.profile.js_pref_salary"
                              :rules="[rules.required]"
                              label="Expected salary *"
                              name="js_pref_salary"
                              type="number">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.profile.js_phone"
                              :rules="[rules.required]"
                              label="Phone *"
                              name="js_phone">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.js_address"
                              :rules="[rules.required]"
                              label="Address *"
                              name="js_address">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <label>About me</label>
                            <vue-editor
                              v-model="dmodaldata.profile.js_desc"
                              placeholder="Description"
                              :rules="[rules.required]">
                            </vue-editor>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-autocomplete
                              v-model="dmodaldata.profile.js_sex"
                              :items="listgender"
                              :rules="[rules.required]"
                              label="Gender *"
                              name="js_sex">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-menu
                              v-model="datepick.birthdate"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="dmodaldata.profile.js_birthdate"
                                  label="Birthday (yyyy-mm-dd) *"
                                  readonly
                                  v-on="on"
                                  :rules="[rules.required]">
                                </v-text-field>
                              </template>
                              <v-date-picker
                                ref="birthday"
                                :max="datepick.date"
                                name="js_birthdate"
                                v-model="dmodaldata.profile.js_birthdate"
                                @input="datepick.birthdate = false">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.profile.js_birthplace"
                              :rules="[rules.required]"
                              label="Birthplace *"
                              name="js_birthplace">
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.updcomp"
                          :disabled="loading.updcomp || !formadd.company"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Update profile
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog add company req -->
    <v-dialog
      v-model="dmodal.addcomr"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Add company request
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('addcomr')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="8">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitAddComr"
                    ref="formaddcomr"
                    v-model="formadd.comr"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="addcomr.comr_name"
                              :rules="[rules.required]"
                              label="Company name *"
                              name="comrname">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="addcomr.comr_email"
                              :rules="[rules.required, rules.email]"
                              label="E-mail *"
                              name="email">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="addcomr.comr_phone"
                              :rules="[rules.required]"
                              label="Company phone *"
                              name="companyphone">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="addcomr.comr_address"
                              :rules="[rules.required]"
                              label="Company address *"
                              name="comr_address">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="addcomr.comr_desc"
                              placeholder="Additional Information">
                            </vue-editor>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.addcomr"
                          :disabled="loading.addcomr || !formadd.comr"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Add request
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog edit company req -->
    <v-dialog
      v-model="dmodal.editcomr"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.editcomr">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Edit company request
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('editcomr')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="8">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitEditcomr"
                    ref="formeditcomr"
                    v-model="formadd.editcomr"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.editcomr.comr_name"
                              :rules="[rules.required]"
                              label="Company name *"
                              name="comrname">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.editcomr.comr_email"
                              :rules="[rules.required, rules.email]"
                              label="E-mail *"
                              name="email">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="dmodaldata.editcomr.comr_phone"
                              :rules="[rules.required]"
                              label="Company phone *"
                              name="companyphone">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="dmodaldata.editcomr.comr_address"
                              :rules="[rules.required]"
                              label="Company address *"
                              name="comr_address">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="dmodaldata.editcomr.comr_desc"
                              placeholder="Additional Information">
                            </vue-editor>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.editcomr"
                          :disabled="loading.editcomr || !formadd.editcomr"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Update request
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog document -->
    <v-dialog
      v-model="dmodal.showdoc"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.showdoc">
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Internship document
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('showdoc')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text">
            <v-col cols="12" md="10">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-tabs
                    v-model="datatabinfo"
                    show-arrows
                    class="font-weight-bold">
                    <v-tabs-slider :color="maincolor"></v-tabs-slider>
                    <v-tab href="#permohonan" active-class="main-style-slide">
                      Permohonan
                    </v-tab>
                    <v-tab href="#pengantar" active-class="main-style-slide">
                      Pengantar
                    </v-tab>
                  </v-tabs>
                  <v-divider></v-divider>
                  <v-tabs-items :touchless="true" v-model="datatabinfo">
                    <v-tab-item value="permohonan">
                      <v-card flat>
                        <v-card-text class="px-0">
                          <v-form
                            @submit.prevent="uploadPermohonan"
                            ref="formupladpermohonan"
                            v-model="formadd.mohon"
                            lazy-validation>
                            <v-row class="black--text" justify="center">
                              <v-col cols="12" md="10">
                                <v-row>
                                  <v-col cols="12" md="12" v-if="alertdata.show">
                                    <alertsp :alertdata="alertdata"></alertsp>
                                  </v-col>
                                  <v-col cols="12" md="10">
                                    <v-file-input
                                      v-model="updatedoc.mohon"
                                      :rules="rules.files"
                                      accept=".pdf"
                                      name="filemohon"
                                      placeholder="Select file"
                                      label="File permohonan"
                                      show-size>
                                    </v-file-input>
                                  </v-col>
                                  <v-col cols="12" md="2">
                                    <v-btn
                                      type="submit"
                                      large
                                      block
                                      :loading="loading.mohon"
                                      :disabled="loading.mohon || !formadd.mohon"
                                      :color="maincolor"
                                      class="white--text mt-1">
                                      Update
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-form>
                          <v-row class="black--text">
                            <v-col cols="12" md="12" v-if="dmodaldata.showdoc.urlskmohon">
                              <div class="mt-2">
                                <iframe
                                  :src="getPdfView(dmodaldata.showdoc.urlskmohon)"
                                  style="width:100%; height:700px;"
                                  frameborder="0">
                                </iframe>
                              </div>
                            </v-col>
                            <v-col cols="12" md="12" v-if="!dmodaldata.showdoc.urlskmohon" class="text-center">
                              <span class="font-weight-bold red--text">
                                You have never uploaded a file!
                              </span>
                            </v-col>
                            <v-col cols="12" md="12">
                              Note: The latest version of your uploaded file is accessible to company that you have applied to
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="pengantar">
                      <v-card flat>
                        <v-card-text class="px-0">
                          <v-form
                            @submit.prevent="uploadPengantar"
                            ref="formupladpengantar"
                            v-model="formadd.antar"
                            lazy-validation>
                            <v-row class="black--text" justify="center">
                              <v-col cols="12" md="10">
                                <v-row>
                                  <v-col cols="12" md="12" v-if="alertdata.show">
                                    <alertsp :alertdata="alertdata"></alertsp>
                                  </v-col>
                                  <v-col cols="12" md="10">
                                    <v-file-input
                                      v-model="updatedoc.antar"
                                      :rules="rules.files"
                                      accept=".pdf"
                                      name="fileantar"
                                      placeholder="Select file"
                                      label="File pengantar"
                                      show-size>
                                    </v-file-input>
                                  </v-col>
                                  <v-col cols="12" md="2">
                                    <v-btn
                                      type="submit"
                                      large
                                      block
                                      :loading="loading.antar"
                                      :disabled="loading.antar || !formadd.antar"
                                      :color="maincolor"
                                      class="white--text mt-1">
                                      Update
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-form>
                          <v-row class="black--text">
                            <v-col cols="12" md="12" v-if="dmodaldata.showdoc.urlskantar">
                              <div class="mt-2">
                                <iframe
                                  :src="getPdfView(dmodaldata.showdoc.urlskantar)"
                                  style="width:100%; height:700px;"
                                  frameborder="0">
                                </iframe>
                              </div>
                            </v-col>
                            <v-col cols="12" md="12" v-if="!dmodaldata.showdoc.urlskantar" class="text-center">
                              <span class="font-weight-bold red--text">
                                You have never uploaded a file!
                              </span>
                            </v-col>
                            <v-col cols="12" md="12">
                              Note: The latest version of your uploaded file is accessible to company that you have applied to
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import Job from '../../components/Job.vue';
import Jobjobseeker from '../../components/Jobjobseeker.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';
import { priceFromat, getGdriveView } from '@/plugins/utils';

export default {
  name: 'DashboardIn',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertpic: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      updcomp: false,
      avatar: false,
      addcomr: false,
      getcomr: false,
      editcomr: false,
      getjobin: false,
      mohon: false,
      saran: false,
    },
    tabdata: 'profile',
    datatabinfo: 'permohonan',
    publickey: '123',
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    datacomr: [],
    datajobin: [],
    jobreclist: [],
    jobsavelist: [],
    jobapplist: [],
    listtype: process.env.VUE_APP_TYPEJOB.split(','),
    listgender: process.env.VUE_APP_GENDER.split(','),
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    listspecial: ['IT-Software', 'IT-Hardware', 'Hotel', 'Tourism', 'Public Relations', 'Banking', 'Accounting'],
    paramjob: {
      special: '',
      type: '',
      location: '',
      keyword: '',
      gaji: [0, 9],
      limit: 20,
      offset: 0,
    },
    paramsave: {
      type: '',
      keyword: '',
      limit: 20,
      offset: 0,
    },
    paramapp: {
      type: '',
      keyword: '',
      limit: 20,
      offset: 0,
    },
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    addcomr: {
      comr_name: '',
      comr_phone: '',
      comr_email: '',
      comr_address: '',
      comr_desc: '',
    },
    formadd: {
      company: false,
      password: false,
      valid: false,
      comr: false,
      editcomr: false,
      mohon: false,
      antar: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    dmodal: {
      profile: false,
      addcomr: false,
      editcomr: false,
      showdoc: false,
    },
    dmodaldata: {
      profile: null,
      editcomr: null,
      showdoc: null,
    },
    myCroppa: {},
    infiniteId: +new Date(),
    infiniteSaveId: +new Date(),
    infiniteAppId: +new Date(),
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      birthdate: false,
    },
    updatedoc: {
      mohon: null,
      antar: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getProfile();
    // init type job
    if (this.userrole === 'student') {
      this.paramjob.type = this.listtype[2];
    } else {
      this.paramjob.type = this.listtype[0];
    }
    // tab
    if (this.$route.query.tab && this.$route.query.tab !== '') {
      this.tabdata = this.$route.query.tab;
    }
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
    dateToAge(value) {
      return value;
    },
  },
  watch: {
    'datepick.birthdate'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  methods: {
    getPdfView(url) {
      return getGdriveView(url);
    },
    changeTab() {
      if (this.tabdata === 'com-req') {
        this.getCompanyreq();
      } else if (this.tabdata === 'internship') {
        this.getJobintern();
      }
    },
    getAppFilter() {
      this.paramapp.offset = 0;
      this.jobapplist = [];
      this.infiniteAppId += 1;
    },
    getAppJob($state) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jobs/apply-js',
            {
              params: this.paramapp,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramapp.offset += this.paramapp.limit;
                  resdata.data.forEach((element) => {
                    element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                    this.jobapplist.push(element);
                  });
                  // this.jobapplist.push(...resdata.data);
                  if (this.jobapplist.length < this.paramapp.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    getSaveFilter() {
      this.paramsave.offset = 0;
      this.jobsavelist = [];
      this.infiniteSaveId += 1;
    },
    getSaveJob($state) {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jobs/save',
            {
              params: this.paramsave,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.paramsave.offset += this.paramsave.limit;
                  resdata.data.forEach((element) => {
                    element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                    this.jobsavelist.push(element);
                  });
                  // this.jobsavelist.push(...resdata.data);
                  if (this.jobsavelist.length < this.paramsave.offset) {
                    if ($state !== false) {
                      $state.complete();
                    }
                  } else {
                    if ($state !== false) {
                      $state.loaded();
                    }
                  }
                } else {
                  if ($state !== false) {
                    $state.complete();
                  }
                }
              }
            }
            // this.loading.check = false;
          })
          .catch((error) => {
            console.log(error);
            // this.loading.check = false;
          });
      }
    },
    getRecomFilter() {
      this.paramjob.offset = 0;
      this.jobreclist = [];
      this.infiniteId += 1;
    },
    getRecJob($state) {
      this.axios
        .get(
          this.api + '/public/jobs',
          {
            params: this.paramjob,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramjob.offset += this.paramjob.limit;
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                  this.jobreclist.push(element);
                });
                // this.jobreclist.push(...resdata.data);
                if (this.jobreclist.length < this.paramjob.offset) {
                  if ($state !== false) {
                    $state.complete();
                  }
                } else {
                  if ($state !== false) {
                    $state.loaded();
                  }
                }
              } else {
                if ($state !== false) {
                  $state.complete();
                }
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    getProfile() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/user/profile',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.datalist = resdata.data;
                if (resdata.data[0].js_picture) {
                  this.datalist[0].urlpic = this.api + '/upload/avatar/' + resdata.data[0].js_picture;
                } else {
                  this.datalist[0].urlpic = '';
                }
                // init data
                this.paramjob.special = this.datalist[0].js_pref_special;
                this.paramjob.location = this.datalist[0].js_pref_location;
                this.paramjob.gaji[1] = (this.datalist[0].js_pref_salary / 1000000);
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    closeDmodal(type) {
      if (type === 'profile') {
        this.dmodal.profile = false;
      } else if (type === 'addcomr') {
        this.dmodal.addcomr = false;
      } else if (type === 'editcomr') {
        this.dmodal.editcomr = false;
      } else if (type === 'showdoc') {
        this.dmodal.showdoc = false;
      } else {
        this.dmodal.profile = false;
      }
    },
    updateProfile(item) {
      this.dmodal.profile = true;
      this.dmodaldata.profile = JSON.parse(JSON.stringify(item));
    },
    submitUpdateProfile() {
      // console.log(this.dmodaldata.profile);
      this.alertupdate.show = false;
      if (this.$refs.formupdprofile.validate()) {
        if (this.tokenscr) {
          this.loading.updcomp = true;
          this.axios
            .put(
              this.api + '/api/user/js-profile',
              qs.stringify(
                this.dmodaldata.profile,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = this.dmodaldata.profile.user_lastname + ' has been changed successfully!';
                  this.getProfile();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.updcomp = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.updcomp = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    getCompanyreq() {
      if (this.tokenscr) {
        this.loading.getcomr = true;
        this.axios
          .get(
            this.api + '/api/companyreq/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datacomr = resdata.data;
                // console.log(this.datacomr);
              }
            }
            this.loading.getcomr = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getcomr = false;
          });
      }
    },
    addCompanyreq() {
      this.dmodal.addcomr = true;
      this.alertupdate.show = false;
    },
    submitAddComr() {
      this.alertupdate.show = false;
      if (this.$refs.formaddcomr.validate()) {
        if (this.tokenscr) {
          this.loading.addcomr = true;
          this.axios
            .post(
              this.api + '/api/companyreq/',
              qs.stringify(
                this.addcomr,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.$refs.formaddcomr.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Your company request "' + resdata.data + '" has been submited!';
                  this.getCompanyreq();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addcomr = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.addcomr = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    editCompanyreq(item) {
      this.dmodal.editcomr = true;
      this.dmodaldata.editcomr = JSON.parse(JSON.stringify(item));
      this.alertupdate.show = false;
    },
    submitEditcomr() {
      this.alertupdate.show = false;
      if (this.$refs.formeditcomr.validate()) {
        if (this.tokenscr) {
          this.loading.editcomr = true;
          this.axios
            .put(
              this.api + '/api/companyreq/',
              qs.stringify(
                this.dmodaldata.editcomr,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Your company request have been changed successfully!';
                  this.getCompanyreq();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editcomr = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.editcomr = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    getJobintern() {
      if (this.tokenscr) {
        this.loading.getjobin = true;
        this.axios
          .get(
            this.api + '/api/jobs/apply-intern',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datajobin = [];
                resdata.data.forEach((element) => {
                  element.urlpic = this.api + '/upload/avatar/' + element.com_picture;
                  element.urlskantar = '';
                  if (element.appin_sk_antar !== '') {
                    element.urlskantar = this.api + '/upload/sk/' + element.appin_sk_antar;
                  }
                  element.urlskmohon = '';
                  if (element.appin_sk_mohon !== '') {
                    element.urlskmohon = this.api + '/upload/sk/' + element.appin_sk_mohon;
                  }
                  this.datajobin.push(element);
                });
                // console.log(this.datajobin);
              }
            }
            this.loading.getjobin = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getjobin = false;
          });
      }
    },
    showDocument(item, tab) {
      this.dmodal.showdoc = true;
      this.datatabinfo = tab;
      this.dmodaldata.showdoc = JSON.parse(JSON.stringify(item));
      this.alertupdate.show = false;
    },
    uploadPermohonan() {
      this.alertdata.show = false;
      if (this.$refs.formupladpermohonan.validate()) {
        if (this.tokenscr) {
          this.loading.mohon = true;
          const dataadd = this.updatedoc;
          const formData = new FormData();
          // file image
          formData.append('filemohon', dataadd.mohon);
          formData.append('oldfilemohon', this.dmodaldata.showdoc.appin_sk_mohon);
          formData.append('appin_id', this.dmodaldata.showdoc.appin_id);
          // send data
          this.axios
            .post(
              this.api + '/api/jobs/apply-intern/uplaodmohon',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.getJobintern();
                  this.dmodaldata.showdoc.appin_sk_mohon = resdata.data.name;
                  this.dmodaldata.showdoc.urlskmohon = this.api + '/upload/resume/' + resdata.data.name;
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Document updated successfully';
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.mohon = false;
            })
            .catch((error) => {
              this.loading.mohon = false;
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    uploadPengantar() {
      this.alertdata.show = false;
      if (this.$refs.formupladpengantar.validate()) {
        if (this.tokenscr) {
          this.loading.antar = true;
          const dataadd = this.updatedoc;
          const formData = new FormData();
          // file image
          formData.append('fileantar', dataadd.antar);
          formData.append('oldfileantar', this.dmodaldata.showdoc.appin_sk_antar);
          formData.append('appin_id', this.dmodaldata.showdoc.appin_id);
          // send data
          this.axios
            .post(
              this.api + '/api/jobs/apply-intern/uplaodantar',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.getJobintern();
                  this.dmodaldata.showdoc.appin_sk_antar = resdata.data.name;
                  this.dmodaldata.showdoc.urlskantar = this.api + '/upload/resume/' + resdata.data.name;
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Document updated successfully';
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.antar = false;
            })
            .catch((error) => {
              this.loading.antar = false;
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
    InfiniteLoading,
    Job,
    Jobjobseeker,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
